export const SELECT_OPEN_OPERATIONS = 'OPERATION/SELECT_OPEN_OPERATIONS';
